import { render, staticRenderFns } from "./ContactRoleTable.vue?vue&type=template&id=3f38f350&"
import script from "./ContactRoleTable.vue?vue&type=script&lang=js&"
export * from "./ContactRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports